import React from "react";

const EditNextOfKin = ({
  id_R,
  editNextOfKinOpen,
  handleCloseEditNextOfKin,
  fullName,
  setFullName,
  relationship,
  setRelationship,
  dateOfBirth,
  setDateOfBirth,
  location,
  setLocation,
  mobileNumber,
  setMobileNumber,
  handleEditNextOfKin,
  loading,
}) => {


  const allFieldsFilled =
    fullName && relationship && dateOfBirth && location && mobileNumber;
  return (
    <>
      <div
        id={id_R}
        className={`${
          editNextOfKinOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow max-w-[100%] mx-auto min-h-[80%] w-[55vw]">
            <div
              onClick={handleCloseEditNextOfKin}
              className="absolute top-[5px] cursor-pointer right-[10px] text-[24px] flex items-center justify-center"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.84 12L5.7 8.9L3.9 12H0.2L3.88 6.3L0.1 0.839999H3.94L6.08 3.92L7.88 0.839999H11.58L7.84 6.46L11.68 12H7.84Z"
                  fill="black"
                />
              </svg>
            </div>
            <div className="p-[20px] mt-8">
              <div className="flex items-center gap-[10px] mb-[30px]">
                <p className="text-[20px] font-bold text-[#000]">
                  Edit next of kin
                </p>
              </div>
              <p className="text-[#000] text-[15px] mb-[20px]">
                Please proceed carefully. Updating next of kin information is a
                sensitive action that requires accuracy and responsibility."
              </p>

              <div className="flex w-full justify-between mt-12 mr-4">
                <div className="flex w-[50%] flex-col justify-center">
                  <label
                    htmlFor="fullNameInput"
                    className="mb-1 text-md font-normal text-[#000]"
                  >
                    Full name
                  </label>
                  <input
                    type="text"
                    id="fullNameInput"
                    name="fullName"
                    placeholder="Enter the full name"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                  />
                </div>
                <div className="flex w-[50%] flex-col justify-center">
                  <label
                    htmlFor="dateOfBirthInput"
                    className="mb-1 text-md font-normal text-[#000]"
                  >
                    Date of birth
                  </label>

                  <input
                    type="date"
                    value={dateOfBirth}
                    onChange={(e) => setDateOfBirth(e.target.value)}
                    className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                  />
                </div>
              </div>

              <div className="flex w-full justify-between mt-12 mr-4">
                <div className="flex w-[50%] flex-col justify-center">
                  <label
                    htmlFor="relationship"
                    className="mb-1 text-md font-normal text-[#000]"
                  >
                    Relationship
                  </label>
                  <input
                    type="text"
                    id="relationship"
                    name="relationship"
                    placeholder="Enter the relationship"
                    value={relationship}
                    onChange={(e) => setRelationship(e.target.value)}
                    className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                  />
                </div>
                <div className="flex w-[50%] flex-col justify-center">
                  <label
                    htmlFor="dateOfBirthInput"
                    className="mb-1 text-md font-normal text-[#000]"
                  >
                    Phone number
                  </label>
                  <input
                    type="text"
                    id="mobileNumberInput"
                    name="mobileno"
                    placeholder="Enter the phone number"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                  />
                </div>
              </div>

              <div className="flex w-full justify-between mt-12 mr-4">
                <div className="flex w-[50%] flex-col justify-center">
                  <label
                    htmlFor="location"
                    className="mb-1 text-md font-normal text-[#000]"
                  >
                    Location
                  </label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    placeholder="Enter the location"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                  />
                </div>
              </div>

              <div className="mt-4 flex justify-end items-centers">
                <button
                  onClick={handleEditNextOfKin}
                  className={`h-[50px] rounded-[5px] text-[#FFFFFF] px-10 flex items-center justify-center 
                    ${allFieldsFilled ? "bg-[#074073]" : "bg-[#D9D9D9]"} 
                    ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
                  disabled={loading || !allFieldsFilled}
                >
                  {loading ? (
                    <div className="flex items-center gap-2">
                      <svg
                        className="animate-spin h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        ></path>
                      </svg>
                      Saving...
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditNextOfKin;
